import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Icon from 'wonderbly-components/lib/Icon';
import RichText from '../../../Prismic/RichText';

const FieldDescription = props => {
  if (!get(props, 'content[0].text')) {
    return null;
  }

  return (
    <div className="field-description">
      <Icon icon="info" />
      <RichText fields={props.content} />
    </div>
  );
};

FieldDescription.propTypes = {
  content: PropTypes.array,
};

export default FieldDescription;



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/Field/FieldDescription/FieldDescription.js